import "@/styles/main.scss";
import { createRoot } from "react-dom/client";
import App from "@/App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
